import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const CompanyRequestsEdit = props => (
  <Edit {...props} resource="companyRequests">
    <Form />
  </Edit>
);

CompanyRequestsEdit.propTypes = {};

export default CompanyRequestsEdit;
